import { useSnackbar } from "notistack";
import React, { useState } from "react";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useParams } from "react-router-dom";
import { QK } from "../../../../../../base/qk";
import {
  createAbbeyPainScale,
  getAbbeyPainScales,
} from "../../../../../../api/services/assessment";
import { formatDateField } from "../../../../../../base/FormatTime";
import { AddCircle, Info, Visibility } from "@mui/icons-material";
import { Box, Button, Card, Stack, Typography } from "@mui/material";
import TableComponent from "../../../../../TableComponent/TableComponent";
import CreateAbbeyPainScaleModal from "./CreateAbbeyPainScaleModal";
import AbbeyPainScaleDetailModal from "./AbbeyPainScaleDetailModal";
import AssessmentRiskTooltip from "../AssessmentRiskTooltip";
import { abbeyPainLevels } from "./painScale.config";

const AbbeyPainScale = () => {
  const [showCreateAssessmentModal, setShowCreateAssessmentModal] =
    useState(false);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [selectedAssessment, setSelectedAssessment] = useState(null);
  const { id: clientID } = useParams();

  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();

  const { data: abbeyPainScales, isLoading } = useQuery(
    [QK.abbeyPainScales, clientID],
    () => getAbbeyPainScales(clientID),
    { enabled: !!clientID, keepPreviousData: true }
  );

  const handleCreateNewAssessment = () => {
    setShowCreateAssessmentModal(true);
  };
  const handleShowDetailsModal = (assessment) => {
    setSelectedAssessment(assessment);
    setShowDetailsModal(true);
  };

  const columns = [
    {
      field: "created_at",
      headerName: "Date",
      render: (value) => formatDateField(value),
    },

    { field: "client_name", headerName: "Service User" },
    { field: "created_by_name", headerName: "Created By" },
    { field: "score", headerName: "Score" },

    {
      field: "comments",
      headerName: "Comments",
    },
  ];

  const actions = [
    {
      icon: <Visibility />,
      color: "primary",
      handler: (assessment) => handleShowDetailsModal(assessment),
    },
  ];

  return (
    <div className="w-75 mx-auto">
      <Card sx={{ mb: 3 }}>
        <Box sx={{ bgcolor: "white", color: "black", p: 2 }}>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
          >
            <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
              <Typography variant="h5">Abbey Pain Scale Assessment</Typography>
              <AssessmentRiskTooltip
                assessmentType="Abbey Pain Scale"
                riskLevels={abbeyPainLevels}
                icon={Info}
                iconColor="info"
                size="small"
                placement="right"
              />
            </Box>

            <Button
              variant="contained"
              startIcon={<AddCircle />}
              color="primary"
              onClick={handleCreateNewAssessment}
            >
              New Assessment
            </Button>
          </Stack>
        </Box>
      </Card>
      <div>
        <TableComponent
          data={abbeyPainScales || []}
          columns={columns}
          actions={actions}
          isLoading={isLoading}
          size="small"
        />
      </div>
      <CreateAbbeyPainScaleModal
        open={showCreateAssessmentModal}
        handleClose={() => setShowCreateAssessmentModal(false)}
      />
      <AbbeyPainScaleDetailModal
        open={showDetailsModal}
        handleClose={() => setShowDetailsModal(false)}
        assessment={selectedAssessment}
      />
    </div>
  );
};

export default AbbeyPainScale;
